var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyNotificationBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a2t5ebwm6a",
    d: "M0 0H32V32H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1196.000000, -64.000000) translate(1196.000000, 64.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2E3A59",
    d: "M24 21.333V14c0-4.093-1.507-7.52-5.333-8.427V2.667h-5.334v2.906C9.52 6.48 8 9.893 8 14v7.333l-2.667 1.334v2.666h21.334v-2.666L24 21.333zm-8 8c1.467 0 2.667-1.2 2.667-2.666h-5.334c0 1.466 1.2 2.666 2.667 2.666.978 0 .978 0 0 0zm-5.333-6.666h10.666V14c0-3.307-1.333-6.333-5.333-6.333S10.667 10.693 10.667 14v8.667z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyNotificationBell);
export default __webpack_public_path__ + "static/media/empty-notification-bell.813c8751.svg";
export { ForwardRef as ReactComponent };